import DataGridComponent from "components/DataGridComponent/DataGridComponent"
import { DeleteDialog } from "components/DeleteDialog/DeleteDialog"
import { TaskConfig, TaskStep } from "graphql/types"
import { useStoreActions, useStoreState } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { getTextForTaskStep } from "utils/taskSteps"
import AddTaskDialog from "./AddTasksDialog"

const emptyTask: TaskConfig = {
  id: "",
  name: "",
  info: "",
  taskSteps: [],
}

const AdminTasks = () => {
  const { taskConfigs } = useStoreState((state) => state)
  const { updateTaskConfig, deleteTaskConfig, fetchTaskConfigs } =
    useStoreActions((actions) => actions)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [formState, setFormState] = useState<TaskConfig>(emptyTask)
  const [openDelete, setOpenDelete] = useState(false)
  const [toDelete, setToDelete] = useState<string[]>([])

  useEffect(() => {
    fetchTaskConfigs()
  }, [fetchTaskConfigs])

  const handleEdit = (id: string) => {
    if (id === "NEW") {
      setFormState({
        ...emptyTask,
        id: "NEW",
      })
    } else {
      const task = taskConfigs.find((t) => t.id === id)
      if (task) {
        setFormState(task)
      }
    }
    setDialogOpen(true)
  }

  const handleDelete = (id: string[]) => {
    setOpenDelete(true)
    setToDelete(id)
  }

  const handleDeleteSelected = () => {
    deleteTaskConfig(toDelete)
    setToDelete([])
    setOpenDelete(false)
  }

  const handleDialogClose = () => {
    setDialogOpen(false)
  }

  const handleFormSubmit = (arg: TaskConfig) => {
    updateTaskConfig(arg)
    setDialogOpen(false)
  }

  const columns = [
    { field: "name", headerName: "Bezeichnung", width: 250 },
    {
      field: "info",
      headerName: "Info",
      width: 300,
    },
    {
      field: "taskSteps",
      headerName: "Schritte",
      width: 300,
      valueGetter: (params: TaskStep[]) => {
        return params.map((step) => getTextForTaskStep(step)).join(", ")
      },
    },
  ]

  return (
    <>
      <DataGridComponent
        columns={columns}
        rows={taskConfigs}
        getRowId={(row) => row.id}
        onEdit={handleEdit}
        onDelete={handleDelete}
        onAdd={() => handleEdit("NEW")}
      />

      <AddTaskDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        formState={formState}
        onSubmit={handleFormSubmit}
      />

      <DeleteDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onDelete={handleDeleteSelected}
      />
    </>
  )
}

export default AdminTasks
